<template>
  <page-layout :title="title">
    <validation-form @on-submit="submitForm" class="pt-2">
      <!-- GENERAL INFORMATION-->
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("zoom_meeting.general_information") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30">
                  <validation-field
                    :validations="zoomValidation.title"
                    name="title"
                  >
                    <label>{{ $t("zoom_meeting.title") }}</label>
                    <md-input
                      :disabled="isEdit && !canEdit"
                      v-model.trim="form.title"
                      required
                    ></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <md-field>
                    <label>{{ $t("common.description") }}</label>
                    <md-input
                      :disabled="isEdit && !canEdit"
                      v-model="form.description"
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-30">
                  <validation-field
                    :validations="zoomValidation.password"
                    name="password"
                  >
                    <label>{{ $t("common.password") }}</label>
                    <md-input
                      :disabled="isEdit && !canEdit"
                      type="password"
                      v-model.trim="form.password"
                    ></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <p>
                    {{ $t("zoom_meeting.a_password_can_only") }}
                  </p>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <p>{{ $t("zoom_meeting.zoom_meeting_type") }}</p>
                </div>
                <div class="md-layout-item md-size-100t">
                  <md-radio
                    :disabled="isEdit && !canEdit"
                    v-model="form.zoom_meeting_type"
                    :value="meetingType.schedule"
                  >
                    {{ $t("zoom_meeting.scheduled_meeting") }}</md-radio
                  >
                  <md-radio
                    :disabled="isEdit && !canEdit"
                    v-model="form.zoom_meeting_type"
                    :value="meetingType.recurring"
                  >
                    {{ $t("zoom_meeting.recurring_meeting") }}</md-radio
                  >
                </div>
              </div>
              <!--scheduled and recurring-->
              <div class="md-layout">
                <div
                  v-if="!isScheduleMeeting"
                  class="md-layout-item md-size-30"
                >
                  <md-field class="flex-1">
                    <label>{{ $t("zoom_meeting.repeat") }}</label>
                    <md-select
                      :disabled="isEdit && !canEdit"
                      v-model="calendar.repeat"
                      name="repeatOpts"
                      id="repeatOpts"
                    >
                      <md-option
                        v-for="(opt, idx) in repeatOpts"
                        :value="opt.value"
                        :key="'opt' + idx"
                      >
                        {{ $t(opt.name) }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div
                  v-if="!isScheduleMeeting"
                  class="md-layout-item md-size-30"
                >
                  <validation-field
                    :validations="zoomValidation.name"
                    name="start date"
                    type="date-picker"
                  >
                    <template #default="{ errors }">
                      <date-picker-custom
                        :label="$t('common.start_date')"
                        :disabled="isEdit && !canEdit"
                        v-model="calendar.start"
                        required
                      >
                        <span class="md-error">{{ errors[0] }}</span>
                      </date-picker-custom>
                    </template>
                  </validation-field>
                </div>
                <div
                  v-if="!isScheduleMeeting"
                  class="md-layout-item md-size-30"
                >
                  <validation-field
                    :validations="zoomValidation.end_date"
                    name="end date"
                    type="date-picker"
                  >
                    <template #default="{ errors }">
                      <date-picker-custom
                        :label="$t('common.end_date')"
                        :disabled="isEdit && !canEdit"
                        v-model="calendar.end"
                      >
                        <span class="md-error">{{ errors[0] }}</span>
                      </date-picker-custom>
                    </template>
                  </validation-field>
                </div>
                <div v-if="isScheduleMeeting" class="md-layout-item md-size-30">
                  <validation-field
                    :validations="{ required: true }"
                    name="start date time"
                    type="date-time-picker"
                  >
                    <template #default="{ errors }">
                      <date-time-picker
                        :disabled="isEdit && !canEdit"
                        :key="cpnKeyDatetime"
                        label="zoom_meeting.start_datetime"
                        :required="true"
                        v-model="calendar.start_date_time"
                      >
                        <span class="md-error">{{ errors[0] }}</span>
                      </date-time-picker>
                    </template>
                  </validation-field>
                </div>
                <div
                  v-if="!isScheduleMeeting"
                  class="md-layout-item md-size-30"
                >
                  <validation-field
                    class="w-full"
                    :validations="zoomValidation.end_date"
                    type="time-picker"
                    name="start time"
                  >
                    <template #default="{ errors }">
                      <isis-time-picker
                        :disabled="isEdit && !canEdit"
                        title="zoom_meeting.start_time"
                        class="m-0 h-[60px] leading-[5px] w-full"
                        v-model="calendar.from_time"
                      >
                        <span class="text-red-600 text-[12px]">{{
                          errors[0]
                        }}</span>
                      </isis-time-picker>
                    </template>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <validation-field
                    :validations="zoomValidation.duration"
                    name="duration"
                    ><label>{{ $t("zoom_meeting.duration_minute") }} </label>
                    <md-input
                      :disabled="isEdit && !canEdit"
                      type="number"
                      v-model="form.duration"
                      required
                    ></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-30">
                  <isis-autocomplete
                    :isDisabled="isEdit && !canEdit"
                    v-model="timezoneDisplay"
                    :value.sync="form.timezone"
                    :options="timeZoneOpts"
                    :label="$t('timezone.timezone')"
                  >
                  </isis-autocomplete>
                </div>
                <div
                  v-if="!isScheduleMeeting"
                  class="md-layout-item md-size-100 md-layout px-0"
                >
                  <div
                    v-if="calendar.repeat === 'weekly'"
                    class="md-layout-item md-size-100 md-layout"
                  >
                    <day-selection
                      :disabled="isEdit && !canEdit"
                      class="md-layout-item md-size-5 px-0"
                      v-for="repeat in calendar.repeat_on"
                      :key="repeat.dayOfWeek.label"
                      :title="repeat.dayOfWeek.label"
                      :repeat="repeat"
                    >
                    </day-selection>
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <!-- GENERAL INFORMATION-->

      <!-- ATTENDEE INFORMATION-->
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("zoom_meeting.attendance_information") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout ">
                <div class="md-layout-item md-size-40">
                  <validation-field
                    :validations="{ required: true }"
                    name="host video "
                    type="autocomplete"
                  >
                    <template #default="{ errors }">
                      <isis-autocomplete
                        :disabled="isEdit && !canEdit"
                        v-model="hostVideo.displayValue"
                        :value.sync="form.host_uuid"
                        :options.sync="hostVideo.options"
                        :refetchOptions="
                          queryObj =>
                            hostVideo.refetchOptions(
                              hostVideo.displayValue,
                              queryObj
                            )
                        "
                        :search-key="hostVideo.searchKey"
                        :fields="hostVideo.fields"
                        :label="hostVideo.label"
                        :class="{ 'md-invalid': !!errors.length }"
                        required
                      >
                        <span class="md-error" style="top:35px">{{
                          errors[0]
                        }}</span>
                      </isis-autocomplete>
                    </template>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-10"></div>
                <div class="md-layout-item md-size-30">
                  <p>
                    {{ $t("zoom_meeting.student_attendance") }}
                  </p>
                  <md-checkbox
                    :disabled="isEdit && !canEdit"
                    v-model="form.student_attendance"
                    class="mt-1 mb-0"
                    >{{ $t("zoom_meeting.record_attendance") }}</md-checkbox
                  >
                </div>
                <div class="md-layout-item md-size-100 flex items-start pt-2">
                  {{ $t("zoom_meeting.guest") }}
                </div>
                <div
                  class="md-layout-item md-size-50 flex md-layout px-0 justify-between"
                >
                  <div class="md-layout-item md-size-50 md-medium-size-100">
                    <md-radio
                      :disabled="isEdit && !canEdit"
                      v-model="form.type_guest"
                      :value="typeGuest.class"
                      >{{ $t("zoom_meeting.select_by_class") }}</md-radio
                    >
                  </div>
                  <div class="md-layout-item md-size-50 md-medium-size-100">
                    <md-radio
                      :disabled="isEdit && !canEdit"
                      v-model="form.type_guest"
                      :value="typeGuest.user"
                      >{{ $t("zoom_meeting.select_by_user") }}
                    </md-radio>
                  </div>
                </div>
                <div
                  v-if="isEdit"
                  class="md-layout-item md-size-50 md-layout flex"
                >
                  <div class="md-layout-item md-size-100 md-layout px-0 flex">
                    <div class="md-layout-item px-0 md-size-100 pr-3">
                      <div class="flex pt-3 items-center px-0">
                        <img
                          src="/img/zoom-icon.svg"
                          class="mr-2 h-[30px] w-[40px]"
                          alt=""
                        />
                        <a
                          class="text-[#0032E3] break-all flex items-center"
                          target="_blank"
                          :href="form.link_zoom"
                          >{{ form.link_zoom }}</a
                        >
                      </div>
                      <div class="md-layout-item md-size-100 px-0">
                        <p class="pt-2 pl-[2px] text-[#9C27B0]">
                          {{ $t("zoom_meeting.meeting_id") }}:
                          {{ form.pmi }}
                        </p>
                      </div>
                    </div>
                    <!--                    <div-->
                    <!--                      class="md-layout-item md-size-40 md-medium-size-100 flex items-start pt-2 px-0"-->
                    <!--                    >-->
                    <!--                      <md-button-->
                    <!--                        :disabled="isEdit && !canEdit"-->
                    <!--                        @click="generateNewZoomMeeting"-->
                    <!--                        type="summit"-->
                    <!--                        class="md-warning"-->
                    <!--                        >{{ $t("zoom_meeting.generate_new_zoom") }}</md-button-->
                    <!--                      >-->
                    <!--                    </div>-->
                  </div>
                </div>
                <div class="md-layout-item md-size-100 md-layout pt-2">
                  <div class="md-layout-item md-size-50 px-0 pb-3">
                    <div class="md-layout-item w-[57%] px-0">
                      <select-component
                        :disabled="isEdit && !canEdit"
                        :label="labelSelect"
                        :key="cpnKeySelectList"
                        :listGuestOptions="listGuestOptions"
                        @filtering="filterList"
                        @open="getListSearch"
                        @close="removeSelected"
                        ref="studentSelectRef"
                        :guestMode="form.type_guest"
                        :disolayField="'display'"
                      ></select-component>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-50"></div>
                  <ul
                    class="min-w-[500px] px-0 max-h-[320px]  overflow-y-scroll pt-2"
                  >
                    <li
                      class="flex justify-between pl-0 pr-3 min-h-[35px] opacity-80 min-w-[300px] hover:opacity-100 hover:text-[#000]"
                      v-for="(item, index) in memorizedSelected"
                      :key="index + 'class or user'"
                    >
                      <div class="flex items-start">
                        <span> {{ index + 1 }}. </span>&nbsp;
                        <span v-if="typeGuestIsClass">{{ item.name }}</span>
                        <div v-else>
                          <span> {{ item.display }}</span>
                        </div>
                      </div>
                      <md-button
                        :disabled="isEdit && !canEdit"
                        class="flex items-end md-simple md-just-icon md-icon-button md-danger h-[15px]"
                        @click.native="deleteStudentAssigned(index)"
                      >
                        <md-icon>delete_forever</md-icon>
                      </md-button>
                    </li>
                  </ul>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <!-- ATTENDEE INFORMATION-->

      <!--      ACCESS SETTING-->
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("zoom_meeting.access_setting") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30">
                  <validation-field
                    :validations="zoomValidation.notification"
                    name="minute"
                  >
                    <label> {{ $t("zoom_meeting.notification_before") }}</label>
                    <md-input
                      v-model.trim="form.notification_before"
                      type="number"
                      max="100"
                    ></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-70 md-layout pt-2">
                  <div class="md-layout-item md-size-25 px-0 flex text-right">
                    <md-switch
                      :disabled="isEdit && !canEdit"
                      v-model="form.join_before_host"
                    >
                      {{ $t("zoom_meeting.join_before_host") }}
                    </md-switch>
                  </div>
                  <div
                    v-if="form.join_before_host"
                    class="md-layout-item md-size-75 px-0 pl-5"
                  >
                    <div>
                      <md-radio
                        :disabled="isEdit && !canEdit"
                        v-model="form.participant_join_before_host"
                        :value="joinBeforeHost.anytime"
                      >
                        {{
                          $t("zoom_meeting.allow_the_participant_anytime")
                        }}</md-radio
                      >
                    </div>
                    <div>
                      <md-radio
                        :disabled="isEdit && !canEdit"
                        v-model="form.participant_join_before_host"
                        :value="joinBeforeHost.five"
                      >
                        {{ $t("zoom_meeting.allow_the_participant_5") }}
                      </md-radio>
                    </div>
                    <div>
                      <md-radio
                        :disabled="isEdit && !canEdit"
                        v-model="form.participant_join_before_host"
                        :value="joinBeforeHost.ten"
                      >
                        {{
                          $t("zoom_meeting.allow_the_participant_10")
                        }}</md-radio
                      >
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <!--      ACCESS SETTING-->

      <!-- FORM ACTIONS -->
      <div class="form-actions">
        <md-button class="md-raised" @click="goToPreviousPage">
          {{ $t("common.cancel") }}
        </md-button>
        <md-button
          :disabled="isEdit && !canEdit"
          @click="editForm"
          type="submit"
          class="md-success"
          >{{ isEdit ? $t("common.update") : $t("common.add") }}</md-button
        >
      </div>
      <!-- FORM ACTIONS -->
    </validation-form>
  </page-layout>
</template>

<script>
import PageLayout from "../../../PageLayout.vue";
import { service_paths, service_names } from "@/constants/Services";
import { hasHistory, getId, genErrMsgOj, Message } from "@/helpers/utils";
import { dataOpts as dataOptsMixin } from "./mixin";
import DaySelection from "../DaySelection";
import SelectComponent from "../GuestSelectComponent";
import pick from "lodash/pick";
import cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import { isDynamicRole, hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";
import { ZoomMeeting } from "@/constants/Permissions";

export default {
  components: { PageLayout, DaySelection, SelectComponent },
  props: ["title", "formProps", "isEdit"],
  mixins: [dataOptsMixin],
  watch: {
    formProps: function(value) {
      if (!value) return;
      this.form = cloneDeep(value);
      this.setHostVideo(value);
    }
  },
  computed: {
    ...mapGetters("user", ["role", "info"]),
    isRoleTeacher() {
      return hasValidRole(this.role, Role.Teacher);
    },
    userId() {
      return getId(this.info);
    },
    canEdit() {
      return (
        hasValidRole(this.role, [Role.Admin, Role.Principal, Role.Teacher]) ||
        (isDynamicRole(this.info, this.role) &&
          this.$can(ZoomMeeting.actions.edit, ZoomMeeting.subject))
      );
    }
  },
  created() {
    this.getHostOpts();
  },
  methods: {
    generateNewZoomMeeting() {
      this.isUpdateSubmit = false;
      this.isGenerateSubmit = true;
    },
    editForm() {
      this.isGenerateSubmit = false;
      this.isUpdateSubmit = true;
    },
    setHostVideo(data) {
      const hostInfo = data.host_zoom_meeting;
      this.hostVideo = {
        ...this.hostVideo,
        displayValue: hostInfo?.host?.full_name + " - " + hostInfo?.host?.email,
        value: hostInfo?.user_uuid,
        host_ui_id: hostInfo?.host?.host_id
      };
      this.form = {
        ...this.form,
        host_uuid: hostInfo?.user_uuid
      };
    },
    removeSelected() {
      this.cpnKeySelectList++;
      this.memorizedSelected = [
        ...this.memorizedSelected,
        ...this.$refs.studentSelectRef?.getMemorizedSelected()
      ];
    },
    deleteStudentAssigned(index) {
      this.memorizedSelected.splice(index, 1);
    },
    submitForm() {
      const form = this.generateFormSubmit();
      if (
        !form.calendar?.repeat_on?.length &&
        !this.isScheduleMeeting &&
        form.calendar.repeat === "weekly"
      ) {
        Message.error(this.$t("zoom_meeting.please_set_up_repeat"));
        return;
      }
      form.timezone = form.timezone || this.info?.school?.timezone;
      if (this.isGenerateSubmit) {
        this.$emit("generateNewZoom", {
          ...form,
          host_ui_id: this.hostVideo.host_ui_id
        });
        return;
      }
      if (this.isUpdateSubmit) {
        let isValidForm = this.setValidForm(form);
        if (!isValidForm) return;
        this.$emit("submitForm", form);
      }
    },
    setValidForm(form) {
      let check = true;
      if (
        !form.calendar?.repeat_on?.length &&
        !this.isScheduleMeeting &&
        form.calendar.repeat === "weekly"
      ) {
        Message.error(this.$t("zoom_meeting.please_set_up_repeat"));
        check = false;
      }
      if (this.typeGuestIsClass && !form.class_id?.length) {
        Message.error(this.$t("zoom_meeting.please_set_up_class"));
        check = false;
      }
      if (!this.typeGuestIsClass && !form.student_uuid?.length) {
        Message.error(this.$t("zoom_meeting.please_set_up_student"));
        check = false;
      }
      return check;
    },
    generateFormSubmit() {
      let form;
      form = pick(this.form, Object.keys(this.defaultFormCfg));
      form.notification_before = +form.notification_before || 0;
      form.calendar = cloneDeep(this.calendar);
      form.calendar.repeat_on = this.calendar?.repeat_on
        ?.filter(item => item.isActivated)
        .map(item => {
          return {
            day_of_week: item.day_of_week,
            from_time: this.calendar.from_time
          };
        });
      if (this.isScheduleMeeting) {
        form.calendar = pick(form.calendar, "start_date_time");
      }
      if (this.typeGuestIsClass) {
        return {
          ...form,
          class_id: this.memorizedSelected.map(item => getId(item))
        };
      }
      return {
        ...form,
        student_uuid: this.memorizedSelected.map(item => item.uuid)
      };
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    async getHostOpts(value) {
      const { data } = await this.$axios.get(
        service_names.school + `/zoom-host`,
        {
          search_key: value
        },
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      this.setHostOpts(data);
    },

    setHostOpts(data) {
      this.hostVideo.options = data.data.map(host => ({
        full_name_email: host.full_name + " - " + host.email,
        ...host
      }));
    },
    filterList(searchKey) {
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.getListSearch(searchKey).then(() => {});
      }, 200);
    },
    async getListClass(searchKey) {
      let path = this.isRoleTeacher
        ? `${service_names.user}/users/${this.userId}/classes`
        : `${service_paths.classes}`;
      let params = {
        ["name__~"]: searchKey || "",
        limit: 100
      };
      const { data } = await this.$axios.get(
        path,
        params,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      this.listGuestOptions = this.setSelectList(data.data);
    },
    async getListStudent(searchKey) {
      let path = this.isRoleTeacher
        ? `${service_names.user}/users/${this.userId}/assigned-students`
        : service_names.user + "/students/filter-with-role";
      let params = {
        limit: 100,
        search_key: searchKey,
        fields: this.isRoleTeacher ? [] : ["full_name", "student_code", "email"]
      };
      const { data } = await this.$axios.get(
        path,
        params,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      this.listGuestOptions = this.setSelectList(data.data);
    },
    async getListSearch(searchKey) {
      if (this.typeGuestIsClass) {
        await this.getListClass(searchKey);
        return;
      }
      await this.getListStudent(searchKey);
    },
    filterClassValid(data) {
      return data.filter(item => item.students?.length);
    },
    setSelectList(data) {
      return data
        .filter(
          student =>
            !this.memorizedSelected.some(item => getId(item) === getId(student))
        )
        .map(item => {
          let display = this.typeGuestIsClass
            ? item.name
            : item.full_name + " - " + item.email + " - " + item.student_code;
          return {
            ...item,
            display: display
          };
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.form-actions {
  padding: 30px 0;
  text-align: center;
  & > * ~ * {
    margin-left: 15px;
  }

  .md-button {
    box-shadow: 0 2px 4px 0 #99999924;
    border-radius: 100px;
  }
}
.md-input {
  min-width: 30% !important;
  max-width: 100%;
}
.list-term {
  font-size: 18px;
  font-weight: 500;
}
.md-error {
  // padding-top: 10px;
  top: 35px !important ;
}
::-webkit-scrollbar {
  appearance: none;
  width: 10px;
  height: 15px;
}

::-webkit-scrollbar-thumb {
  background: #e3e2e2;
  border-radius: 15px;
}
</style>
